/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SourcingSearchExperience
 */
export interface SourcingSearchExperience {
    /**
     * 
     * @type {string}
     * @memberof SourcingSearchExperience
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof SourcingSearchExperience
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof SourcingSearchExperience
     */
    company?: string;
    /**
     * 
     * @type {Date}
     * @memberof SourcingSearchExperience
     */
    startDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof SourcingSearchExperience
     */
    endDate?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof SourcingSearchExperience
     */
    currentJob?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof SourcingSearchExperience
     */
    skills?: Array<string>;
}

/**
 * Check if a given object implements the SourcingSearchExperience interface.
 */
export function instanceOfSourcingSearchExperience(value: object): value is SourcingSearchExperience {
    return true;
}

export function SourcingSearchExperienceFromJSON(json: any): SourcingSearchExperience {
    return SourcingSearchExperienceFromJSONTyped(json, false);
}

export function SourcingSearchExperienceFromJSONTyped(json: any, ignoreDiscriminator: boolean): SourcingSearchExperience {
    if (json == null) {
        return json;
    }
    return {
        
        'description': json['description'] == null ? undefined : json['description'],
        'title': json['title'] == null ? undefined : json['title'],
        'company': json['company'] == null ? undefined : json['company'],
        'startDate': json['startDate'] == null ? undefined : (new Date(json['startDate'])),
        'endDate': json['endDate'] == null ? undefined : (new Date(json['endDate'])),
        'currentJob': json['currentJob'] == null ? undefined : json['currentJob'],
        'skills': json['skills'] == null ? undefined : json['skills'],
    };
}

export function SourcingSearchExperienceToJSON(value?: SourcingSearchExperience | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'description': value['description'],
        'title': value['title'],
        'company': value['company'],
        'startDate': value['startDate'] == null ? undefined : ((value['startDate']).toISOString().substring(0,10)),
        'endDate': value['endDate'] == null ? undefined : ((value['endDate']).toISOString().substring(0,10)),
        'currentJob': value['currentJob'],
        'skills': value['skills'],
    };
}

